import { CurrentPlanProjection, Nullable } from '@xplan-pension-switching/common';
import { TableColumn } from '@iress-oss/ids-components';
import { sortIdsComponent } from '../../helpers/SortIdsComponent/SortIdsComponent';

export type CurrentPlanProjectionsTableProps = {
    entityId: number;
    scenarioId: Nullable<number>;
    ownerId: Nullable<number>;
    currentPlanProjections: CurrentPlanProjection[];
};
export const columnDefs: TableColumn<CurrentPlanProjection>[] = [
    {
        key: 'nameCell',
        label: 'Plan',
        width: '50%',
        format: 'string',
        sort: true,
        sortFn: (a, b) => sortIdsComponent('nameStringValue', a.original, b.original),
    },
    {
        key: 'planValue',
        label: 'Current value (GBP)',
        align: 'right',
        width: '25%',
        format: 'currency',
        currencyCode: '',
        sort: true,
    },
    {
        key: 'isCompletedCell',
        label: 'Status',
        width: '25%',
        sort: true,
        format: 'string',
        sortFn: (a, b) => sortIdsComponent('isCompletedString', a.original, b.original),
    },
];
